import { EventItem } from "features/events/eventApi";

export function isVariantClosed(variant_id: number, event?: EventItem) {
  return !!event?.closed?.includes(variant_id);
}
